import {
  HeroConversationMessage,
  ConversationMessageAuthor,
  ConversationMessageType,
  Product,
} from '@vs-online-only-app/state';
import { v4 as uuid } from 'uuid';

export const createLocalProductMessage = ({
  conversationId,
  author,
  product,
}: {
  conversationId: string;
  product: Product;
  author: ConversationMessageAuthor | string;
}) => {
  const id = uuid();
  const message: HeroConversationMessage = {
    attributes: {
      type: ConversationMessageType.Product,
      localMessageId: id,
      heroConversationId: conversationId,
      data: {
        skuCode: product.sku,
        image: product.thumbnail,
        originalPrice: product.price,
        price: product.salePrice,
        title: product.title,
        currency: product.currency,
        url: product.url,
      },
    },
    author,
    body: '',
    conversation: { sid: conversationId },
    lastUpdatedBy: null,
    sid: id,
    dateCreated: new Date(),
    dateUpdated: null,
    type: 'text',
  };

  return message;
};

export const createLocalMediaMessage = ({
  conversationId,
  author,
  mediaType,
  mediaUrl,
}: {
  conversationId: string;
  author: ConversationMessageAuthor | string;
  mediaType: 'photo' | 'video';
  mediaUrl: string;
}) => {
  const id = uuid();
  const message: HeroConversationMessage = {
    attributes: {
      type:
        mediaType === 'photo'
          ? ConversationMessageType.Photo
          : ConversationMessageType.Video,
      localMessageId: id,
      heroConversationId: conversationId,
      mediaUrl,
      data: {},
    },
    author,
    body: '',
    conversation: { sid: conversationId },
    lastUpdatedBy: null,
    dateUpdated: null,
    sid: id,
    dateCreated: new Date(),
    type: 'media',
  };

  return message;
};

export const createLocalTextMessage = ({
  conversationId,
  author,
  body,
}: {
  conversationId: string;
  author: ConversationMessageAuthor | string;
  body: string;
}) => {
  const id = uuid();
  const message: HeroConversationMessage = {
    attributes: {
      type: ConversationMessageType.Text,
      localMessageId: id,
      heroConversationId: conversationId,
      data: {},
    },
    author,
    body,
    conversation: { sid: conversationId },
    lastUpdatedBy: null,
    sid: id,
    dateCreated: new Date(),
    dateUpdated: null,
    type: 'text',
  };

  return message;
};

export const createLocalTimestampMessage = ({
  conversationId,
  author,
  dateCreated,
}: {
  conversationId: string;
  author: ConversationMessageAuthor;
  dateCreated: Date;
}) => {
  const message: HeroConversationMessage = {
    attributes: {
      type: ConversationMessageType.Timestamp,
      localMessageId: uuid(),
      heroConversationId: conversationId,
      data: {},
    },
    author,
    body: '',
    conversation: { sid: conversationId },
    lastUpdatedBy: null,
    sid: uuid(),
    dateCreated,
    dateUpdated: null,
    type: 'text',
  };

  return message;
};

export const truncateText = (text: string, limit = 16): string => {
  if (text.length > limit) {
    return `${text.substring(0, limit)}...`;
  }
  return text;
};

export const truncateMessagesCount = (count?: number | null): string => {
  if (!count) {
    return '';
  }
  if (count > 99) {
    return '99+';
  }
  return count.toString();
};
